module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/header-image-mobile-01-2addfc74033bb4b8ca4c9ebb6ef357e5.jpg";